<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-rank"></i> 设备管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>设备列表</el-breadcrumb-item>
                <el-breadcrumb-item>设备详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="deviceBaseInfoTitle">基本信息</span>
                </div>
                <div class="deviceBaseInfoContent">
                    <el-container>
                        <el-main>
                            <el-row>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备ID:</div>
                                            <div
                                                class="infoValue"
                                            >{{ deviceDeatil.FrameWorkDeviceName }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备别名:</div>
                                            <div
                                                class="infoValue"
                                            >{{ deviceDeatil.CustomName ? deviceDeatil.CustomName : '无' }}</div>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备类型:</div>
                                            <div class="infoValue">{{ deviceDeatil.FrameWorkTags }}</div>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备状态:</div>
                                            <div class="infoValue">{{ deviceDeatil.DeviceStatus}}</div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备图片:</div>
                                            <div class="infoValue">
                                                <el-button @click="showImgPriverFunc" type="primary">查看</el-button>
                                                <el-image-viewer
                                                    v-if="showImgPriver"
                                                    :on-close="hidImgPriverFunc"
                                                    :url-list="[deviceDeatil.Pic_url]"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">安装纬度:</div>
                                            <div
                                                class="infoValue"
                                            >{{ deviceDeatil.latitude ? deviceDeatil.latitude : '无' }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">安装经度:</div>
                                            <div
                                                class="infoValue"
                                            >{{ deviceDeatil.longitude ? deviceDeatil.longitude : '无' }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">更新时间:</div>
                                            <div
                                                class="infoValue"
                                            >{{ deviceDeatil.UpdateTime ? deviceDeatil.UpdateTime : '无' }}</div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple">
                                        <div class="infoBox">
                                            <div class="infolabel">创建时间:</div>
                                            <div class="infoValue">{{ deviceDeatil.CreateTime }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">创建人:</div>
                                            <div class="infoValue">{{ deviceDeatil.CreaterID }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">安装位置:</div>
                                            <div
                                                class="infoValue"
                                            >{{ deviceDeatil.Installation_location ? deviceDeatil.Installation_location : '无' }}</div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-main>
                        <el-aside width="200px">
                            <div id="qrCode" ref="qrCodeDiv" class="ercodeCov"></div>
                        </el-aside>
                    </el-container>
                </div>
            </el-card>

            <el-card class="box-card mrt">
                <div slot="header" class="clearfix">
                    <span class="deviceBaseInfoTitle">设备属性</span>
                </div>
                <div class="deviceValueInfoContent">
                    <el-row :gutter="20" v-for="itemO in doubleArrDeviceData">
                        <el-col :span="4" v-for="item in itemO">
                            <el-card class="box-card curson" shadow="hover">
                                <div class="infolabel">{{item.label}}</div>
                                <div class="infoValue">{{ item.value }}</div>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </el-card>

            <el-card class="box-card mrt">
                <div slot="header" class="clearfix">
                    <span class="deviceBaseInfoTitle">历史属性</span>
                    <div style="float: right; padding: 3px 0" type="text">
                        <el-date-picker
                            v-model="historySelectDate"
                            type="daterange"
                            class="marginLr"
                            align="right"
                            unlink-panels
                            @change="historySelectDateChange"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            :picker-options="pickerOptions"
                        ></el-date-picker>
                        <el-button type="primary">查询</el-button>
                    </div>
                </div>
                <div>
                    <div class="historyValueBox" ref="historyValue"></div>
                </div>
            </el-card>

            <el-card class="box-card mrt">
                <div slot="header" class="clearfix">
                    <span class="deviceBaseInfoTitle">事件信息</span>
                    <div style="float: right; padding: 3px 0" type="text">
                        <el-date-picker
                            v-model="eventDateValue"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                        ></el-date-picker>
                        <el-select v-model="dateSelectValue" placeholder="请选择事件类型" class="marginLr">
                            <el-option
                                v-for="item in dateSelectOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                        <el-button type="primary">查询</el-button>
                        <el-button type="primary">刷新</el-button>
                        <el-button type="primary">导出</el-button>
                    </div>
                </div>
                <div>
                    <div>
                        <el-table
                            :data="tableDatas"
                            border
                            class="table"
                            ref="multipleTable"
                            header-cell-class-name="table-header"
                        >
                            <el-table-column prop="time" label="事件时间" width="180" align="center"></el-table-column>

                            <el-table-column prop="type" label="事件类型" width="180" align="center"></el-table-column>
                            <el-table-column prop="content" label="事件内容"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { Device } from '../../api';
import moment from 'moment';
import QRCode from 'qrcodejs2';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
    data() {
        return {
            // 大图预览窗口是否打开
            showImgPriver: false,
            srcList: ['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'],
            // 日期快捷选项
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            // 历史属性日期范围值
            historySelectDate: [new Date().getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
            // 事件信息日期范围值
            eventDateValue: [new Date().getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
            // 设备参数信息
            descArr: [],
            // 设备信息
            deviceDeatil: {},
            dateSelectValue: '',
            dateSelectOptions: [
                {
                    value: '设备信息上报',
                    label: '设备信息上报'
                },
                {
                    value: '业务数据上报',
                    label: '业务数据上报'
                },
                {
                    value: '报警',
                    label: '报警'
                },
                {
                    value: '故障',
                    label: '故障'
                }
            ],

            deviceData: {},
            tableDatas: [
                {
                    time: '2022-08-26 12:22:08',
                    type: '设备信息上报',
                    content: '设备信息内容'
                },
                {
                    time: '2022-08-26 12:22:08',
                    type: '设备信息上报',
                    content: '设备信息上报内容'
                },
                {
                    time: '2022-08-26 12:22:08',
                    type: '业务数据上报',
                    content: '业务数据上报内容'
                },
                {
                    time: '2022-08-26 12:22:08',
                    type: '业务数据上报',
                    content: '业务数据上报内容'
                },
                {
                    time: '2022-08-26 12:22:08',
                    type: '设备信息上报',
                    content: '业务数据上报'
                }
            ]
        };
    },
    created() {
        this.getData();
        this.erCodeBtn();
    },
    computed: {
        doubleArrDeviceData() {
            let result = [];
            let arr = [];
            // 将获得的设备属性进行数组格式化
            this.descArr.forEach(item => {
                let obj = {
                    tag: item[0],
                    label: item[1],
                    value: item[2]
                };
                arr.push(obj);
            });
            let newArr = [];
            arr.forEach((item, index) => {
                // 第0项
                if (index === 0) {
                    newArr = [item];
                } else if (index == arr.length - 1) {
                    // 最后一项
                    newArr.push(item);
                    result.push(newArr);
                } else if (index % 6 !== 0) {
                    newArr.push(item);
                } else {
                    result.push(newArr);
                    newArr = [];
                    newArr.push(item);
                }
            });
            return result;
        }
    },
    mounted() {
        this.buildHistoryValueEchart();
    },
    methods: {
        // 查看大图
        showImgPriverFunc() {
            this.showImgPriver = true;
        },
        // 关闭大图
        hidImgPriverFunc() {
            this.showImgPriver = false;
        },
        // 设备属性历史曲线日期选择值变化
        historySelectDateChange(e) {
            console.log(new Date(e[0]).getTime());
            console.log(new Date(e[1]).getTime());
        },
        //  设备属性历史曲线图标生成
        buildHistoryValueEchart() {
            let historyValue = this.$echarts.init(this.$refs.historyValue);
            historyValue.setOption({
                grid: {
                    bottom: 25,
                    top: 80,
                    left: 80,
                    right: 80
                },
                xAxis: {
                    type: 'category',
                    data: ['2022-10-21', '2022-10-21', '2022-10-21', '2022-10-21', '2022-10-21', '2022-10-21', '2022-10-21']
                },
                tooltip: {
                    trigger: 'axis'
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: [123, 45, 123, 45, 123, 45, 123],
                        type: 'line'
                    }
                ]
            });
        },

        // 生成设备二维码
        erCodeBtn() {
            this.$nextTick(function() {
                new QRCode(this.$refs.qrCodeDiv, {
                    text: `${this.$router.currentRoute.query.id}
                   `,
                    width: 150,
                    height: 150,
                    colorDark: '#333333', //二维码颜色
                    colorLight: '#ffffff', //二维码背景色
                    correctLevel: QRCode.CorrectLevel.H //容错率，L/M/H
                });
            });
        },

        // 每日设备状态折线图数据处理
        beforDeviceDataComputerLine() {
            let arr = this.$store.state.deviceBefore;
            let xData = arr.map(item => {
                return item.date;
            });
            let vSeries = [];
            // let normalObj = {};
            // let alarmObj = {};
            // let trouleObj = {};
            let normalDataArr = [];
            let alarmDataArr = [];
            let trouleDataArr = [];
            this.$store.state.deviceBefore.forEach(item => {
                normalDataArr.push(item.normal);
                alarmDataArr.push(item.alarm);
                trouleDataArr.push(item.troule);
            });
            // vSeries.push(normalObj,alarmObj,trouleObj)

            vSeries.push({
                name: '正常',
                type: 'line',
                itemStyle: {
                    color: '#08d97b'
                },
                data: normalDataArr
            });

            vSeries.push({
                name: '报警',
                type: 'line',
                itemStyle: {
                    color: '#e83c03'
                },
                data: alarmDataArr
            });
            vSeries.push({
                name: '故障',
                type: 'line',
                itemStyle: {
                    color: '#ff8115'
                },
                data: trouleDataArr
            });

            console.log('vSeries');
            console.log(vSeries);

            return {
                xData,
                vSeries
            };
        },
        // 获取设备数据
        async getData() {
            let id = this.$router.currentRoute.query.id;
            if (id !== null && id !== undefined && id !== '') {
                const DeviceResult = await Device({ deviceID: id });
                console.log(DeviceResult);

                if (DeviceResult.status !== 1) {
                    this.$message.error('错误');
                    return;
                }
                let resultData = JSON.parse(DeviceResult.message);
                console.log(resultData);
                this.deviceDeatil = resultData;
                this.deviceDeatil.CreateTime = moment(this.deviceDeatil.CreateTime * 1).format('YYYY-MM-DD H:mm:ss');
                console.log(JSON.parse(resultData.Details));
                switch (this.deviceDeatil.Device_status) {
                    case 0:
                        this.deviceDeatil.DeviceStatus = '正常';
                        break;
                    case 1:
                        this.deviceDeatil.DeviceStatus = '故障';
                        break;
                    case 2:
                        this.deviceDeatil.DeviceStatus = '维护';
                        break;

                    default:
                        break;
                }
                resultData.Details = JSON.parse(resultData.Details);
                console.log(resultData);
                let arr = [];
                for (const key in resultData.Details.data) {
                    for (const item in resultData.Details.model) {
                        if (key == item) {
                            if (resultData.Details.data[key] === false || resultData.Details.data[key] === true) {
                                arr.push([key, resultData.Details.model[key], resultData.Details.data[key] ? '是' : '否']);
                            } else {
                                arr.push([key, resultData.Details.model[key], resultData.Details.data[key]]);
                            }
                        }
                    }
                }
                this.descArr = arr;
                console.log(arr);
            } else {
                // 参数不存在 跳回
                this.$router.go(-1);
                // DeviceDetail
                setTimeout(() => {
                    this.$message({
                        showClose: true,
                        message: '错误,没有设备id',
                        type: 'error'
                    });
                }, 1000);
            }
        }
    },
    components: {
        ElImageViewer
    }
};
</script>

<style lang="less" scoped >
.deviceBaseInfoTitle {
    font-size: 0.5rem;
}
.deviceBaseInfoContent {
    .infoBox {
        display: flex;
        font-size: 17px;
        margin: 10px 0;
        align-items: center;
        .infolabel {
            color: #909399;
            margin-right: 5px;
            width: 90px;
            text-align: right;
        }
        .infoValue {
        }
    }
}
.deviceValueInfoContent {
    font-size: 17px;
    margin: 10px;
    .box-card {
        margin: 10px 0;
    }
    .infolabel {
        color: #909399;
        text-align: center;
    }
    .infoValue {
        text-align: center;
        margin-top: 10px;
    }
}
.el-tag.el-tag--success {
    color: #ffffff;
}
.margin-top {
    margin-top: 10px;
}
.detaFilter {
    margin-top: -30px;
    margin-bottom: 10px;
}
.marginLr {
    margin-left: 10px;
    margin-right: 10px;
}
.one {
    width: 100%;
    height: 400px;
}
.llll {
    margin-left: 10px;
}
.ercodeCov {
    display: flex;
    justify-content: center;
    align-items: center;
}
.mrt {
    margin-top: 20px;
}
.historyValueBox {
    width: 100%;
    height: 300px;
}
.curson {
    cursor: pointer;
}
.deviceImg {
    width: 50px;
    height: 50px;
}
</style>